import { Check, ChevronRight, FileText, ScanSearch, Send } from "lucide-react";
import { Fragment } from "react";
import content from "../../data/content.json";

const ICONS = [FileText, ScanSearch, Send];
const STEPS = content.steps.map((label, i) => ({ label, icon: ICONS[i] ?? FileText }));

export function Stepper({ current = 0 }: { current?: number }) {
  return (
    <ol data-testid="niche-stepper" className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-2">
      {STEPS.map(({ label, icon: Icon }, i) => {
        const state = i < current ? "done" : i === current ? "active" : "upcoming";
        const box =
          state === "active"
            ? "border-emerald-500 bg-emerald-500 text-slate-950"
            : state === "done"
              ? "border-emerald-500/60 text-emerald-400"
              : "border-slate-700 text-slate-500";
        return (
          <Fragment key={label}>
            <li data-testid={`stepper-step-${i + 1}`} data-state={state} aria-current={state === "active" ? "step" : undefined} className="flex items-center gap-3">
              <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md border transition-colors duration-300 ${box}`}>
                {state === "done" ? <Check aria-hidden="true" className="h-4 w-4" /> : <Icon aria-hidden="true" className="h-4 w-4" />}
              </span>
              <span className={`text-sm ${state === "active" ? "font-semibold text-slate-100" : state === "done" ? "text-slate-300" : "text-slate-400"}`}>
                {i + 1}. {label}
              </span>
            </li>
            {i < STEPS.length - 1 && <ChevronRight aria-hidden="true" className="hidden h-4 w-4 shrink-0 text-slate-600 sm:block" />}
          </Fragment>
        );
      })}
    </ol>
  );
}
